import axios from 'axios';
import ErrorMessageResolver from 'resolvers/error-message.resolver';
import toastMessageResolver from 'resolvers/toast-message-by-code.resolver';
import AuthService from 'services/auth.service';
import layoutNames from 'utils/enums/layout-names.enum';

const publicResources = [];

export default function setup(history) {
  axios.interceptors.request.use(
    (config) => {
      const auth = AuthService.getCurrentUser()
      if (
        auth && !publicResources.some((item) => (config.url || '').includes(item))
      ) {
        config.headers.common['x-access-token'] = auth?.accessToken;
      }
      return config;
    },
    (err) => Promise.reject(err),
  );

  axios.interceptors.response.use(
    (response) => response.data,
    (error) => {
			if (error && error.response) {
				if (error.response.status === 401) {
					let message;
					if (error.response.data && error.response.data.errorCode) {
						message = toastMessageResolver(error.response.status, error.response.data.errorCode);
					}

					AuthService.logout();
					history.push({
						pathname: `/${layoutNames.auth}/login`,
						message,
					});
				}
			}
			const handledError = ErrorMessageResolver.resolve(error);

      // if ((error.response || {}).status === 401) {
      //   history.push(`${layoutNames.auth}/login`);
      //   // store.dispatch('session/logout').then(() => {
      //   // store.dispatch('session/logout').then(() => {
      //   //   history.push('/login');
      //   // });
      // }

      return Promise.reject(handledError);
    },
  );
}
